import React from 'react';
import ReactDOM from 'react-dom/client';
import { AppShell } from './AppShell';
import './index.css';
import './i18n';

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AppShell />
  </React.StrictMode>
);
